import { jwtDecode } from 'jwt-decode';

/**
 * Idiomas soportados por la interfaz. Añadir uno nuevo aquí y crear su JSON en
 * `locales/` es todo lo que hace falta: el selector y el detector leen de aquí.
 * `bandera` es la ruta del SVG en /public/images: los emoji de bandera no se
 * dibujan igual en Windows ni en algunos Android, así que no valen.
 */
export const IDIOMAS = [
  { codigo: 'es', nombre: 'Español', corto: 'ES', bandera: '/images/spain.svg' },
  { codigo: 'en', nombre: 'English', corto: 'EN', bandera: '/images/uk.svg' },
];

export const IDIOMA_POR_DEFECTO = 'es';

export const CLAVE_ALMACENAMIENTO = 'idiomaPreferido';

export const esIdiomaSoportado = (codigo) =>
  IDIOMAS.some((idioma) => idioma.codigo === codigo);

/** Normaliza "en-GB", "ES", "en_US"… al código corto que sí soportamos. */
export const normalizarIdioma = (valor) => {
  if (!valor) return null;
  const corto = String(valor).toLowerCase().split(/[-_]/)[0];
  return esIdiomaSoportado(corto) ? corto : null;
};

/** Preferencia guardada en la cuenta, leída del token de sesión. */
export const idiomaDelToken = () => {
  try {
    const token = localStorage.getItem('AuthToken');
    if (!token) return null;
    return normalizarIdioma(jwtDecode(token).idioma);
  } catch (err) {
    return null;
  }
};

export const idiomaGuardado = () => {
  try {
    return normalizarIdioma(localStorage.getItem(CLAVE_ALMACENAMIENTO));
  } catch (err) {
    return null;
  }
};

export const idiomaDelNavegador = () => {
  const candidatos = navigator.languages || [navigator.language];
  for (const candidato of candidatos) {
    const idioma = normalizarIdioma(candidato);
    if (idioma) return idioma;
  }
  return null;
};

/**
 * Idioma que toca usar ahora mismo. La cuenta manda sobre todo lo demás: si el
 * usuario eligió inglés en su perfil, ese es su idioma en cualquier navegador.
 * Sin sesión se respeta lo último elegido en el selector y, en su defecto, el
 * idioma del navegador.
 */
export const resolverIdioma = () =>
  idiomaDelToken() || idiomaGuardado() || idiomaDelNavegador() || IDIOMA_POR_DEFECTO;
